var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 344.69546 365.28825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#6740a3;stroke-miterlimit:10;stroke-width:4px;}.cls-2{fill:#a2dfd9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.50066,286.4247C-17.60032,220.63649,5.68837,144.07155,8.51769,135.3077,35.66094,51.23037,128.98317-16.53416,213.79427,3.56301c69.67308,16.51001,102.04419,84.00372,108.76596,98.04254,30.35587,63.40021,37.73592,167.61542-31.7619,226.72382-78.21155,66.51953-208.77426,37.62781-263.29767-41.90466Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.62031,35.48238c10.85839.25517,18.25663,2.20794,24.54776,11.54425,5.64802,8.38191,22.13734,41.67639,23.31064,50.82625,3.72605,29.0573-14.63757,35.06546-27.65931,54.41335-11.54281,17.15047,2.54902,41.66429,12.30402,57.03832,9.9723,15.71649,37.40505,45.05845,55.13159,50.62069,24.23978,7.60597,40.44065-22.15303,67.7092-19.63434,15.34141,1.41703,43.62635,23.34902,55.02928,34.35246,23.09135,22.28237-6.63105,71.86849-34.23347,73.69251-56.75087,3.75021-125.14156-46.85736-160.72122-87.44266C67.05695,215.2864,21.03961,129.69148,38.07013,67.28863c5.46058-20.00852,34.42839-32.2556,53.55018-31.80625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.df2c122112e7bb7c95e8c9f3df946f5e.svg";
export { ForwardRef as ReactComponent };